import React from "react";
import { ReactElementFactory } from "../../element-factory";

export class ActionBarSeparator extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
  }
  render() {
    var className = `sv-action-bar-separator ${this.props.cssClasses}`;
    return <div className={className}></div>;
  }
}
ReactElementFactory.Instance.registerElement(
  "sv-action-bar-separator",
  (props) => {
    return React.createElement(ActionBarSeparator, props);
  }
);



// WEBPACK FOOTER //
// ./src/react/components/action-bar/action-bar-separator.tsx